<template>


  <div class="extra_banners extra--mobile" >
    <div class="row">
      <div v-for="banner in extra_banners" class="col-sm-6 extra_banner">
        <a :href="banner.link" :title="banner.title">
          <picture>
            <source :srcset="banner.mobile_image.webp" type="image/webp">
            <img :src="banner.mobile_image.source" alt="image" data-sizes="auto" width="300" height="300" class="img  mx-auto lazyload">
          </picture>
        </a>
      </div>
    </div>
  </div>


  <div class="extra_banners extra--desktop">
    <div class="row">
      <div v-for="banner in extra_banners" class="col-sm-6 extra_banner">
        <a :href="banner.link" :title="banner.title">
          <picture>
            <source :srcset="banner.desktop_image.webp" type="image/webp">
            <img :src="banner.desktop_image.source" alt="image" data-sizes="auto" width="350" height="350" class="img  mx-auto lazyload">
          </picture>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name:  "Extras",
  props: [
    'extra_banners'
  ],
}
</script>